// CodeMismatchExceptionMsg is a bit long to include in the map

import Link from "next/link";
import { ReactNode } from "react";

// directly so declaring here.
const CodeMismatchExceptionMsg = (
  <span>
    The code you provided was not valid. Please note:
    <br />
    <ul style={{ listStyleType: "circle", paddingLeft: "1rem" }}>
      <li>Try to resend the verification email by clicking ‘Resend’.</li>
      <li>
        If you have received multiple emails, make sure to use the code in the
        most recent email.
      </li>
      <li>
        If the email you received is older than 24 hours, request a new email by
        clicking ‘Resend’.
      </li>
      <li>
        Check your spam emails to make sure emails have not been sent there.
      </li>
    </ul>
  </span>
);

// Known AWS errors with a label we can show users.
export const authErrorLabels: { [key: string]: ReactNode } = {
  AliasExistsException: <span>Email not available.</span>,
  ExpiredCodeException: <span>Invalid confirmation code.</span>,
  InvalidPasswordException: <span>Invalid password format.</span>,

  InvalidUsernameException: (
    <span>
      Name may only contain up to 41 lowercase letters, numbers, and
      underscores.
    </span>
  ),
  NotAuthorizedException: <span>Incorrect username or password.</span>,
  UnknownErrorException: <span>An unknown error occured.</span>,
  UsernameExistsException: <span>Username not available.</span>,
  EmailDomainBlockedException: <span>An unknown signup error occured.</span>,
  InvalidUserName: <span>Username is not valid.</span>,
  UserNotFoundException: <span>Username does not exist.</span>,
  EmailNotFoundException: <span>Email address not found.</span>,
  CodeMismatchException: CodeMismatchExceptionMsg,
  LimitExceededException: (
    <span>Limit exceeded. Please try again after some time.</span>
  ),
  UserAlreadyConfirmed: (
    <span>
      This account is already confirmed. <Link href="/auth/login">Login</Link>
    </span>
  ),
  EmailNotVerified: (
    <span>
      Email is not verifed. Please{" "}
      <Link href="/auth/registerConfirm">verify your email</Link>.
    </span>
  ),
};
